import { Fade as MuiFade } from '@material-ui/core';
import { useEffect, useState } from 'react';

export const Fade = ({ visible, delay = 0, ...props }) => {
    const [isFadedIn, setIsFadedIn] = useState(false);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsFadedIn(visible);
        }, delay);
        return () => {
            clearTimeout(timeout);
        };
    }, [visible, delay]);
    return <MuiFade in={isFadedIn} {...props} />;
};
